import script from "./RankingEjercitos.vue?vue&type=script&setup=true&lang=ts"
export * from "./RankingEjercitos.vue?vue&type=script&setup=true&lang=ts"

import "./RankingEjercitos.vue?vue&type=style&index=0&id=7868c2b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7868c2b4"]])

export default __exports__